var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var turtleTokenTypes = require('../turtle/tokens').turtleTokenTypes;
import { turtleTokenMap } from 'turtle/tokens';
import { sparqlTokenMap } from 'sparql/tokens';
export var trigTokenMap = __assign({ GRAPH: sparqlTokenMap.GRAPH }, turtleTokenMap);
var indexOfPnCharsBase = turtleTokenTypes.indexOf(turtleTokenMap.PN_CHARS_BASE);
export var trigTokenTypes = turtleTokenTypes.slice(0, indexOfPnCharsBase).concat([
    sparqlTokenMap.GRAPH
], turtleTokenTypes.slice(indexOfPnCharsBase));
